import { IconProps } from "./Icon.model";

export function AiVisionRecognition({
  size = 16,
  fill = "currentColor",
}: IconProps) {
  const fillColor =
    fill === "currentColor" ? "currentColor" : `var(--${fill}-a8)`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4.25C15.536 4.25005 18.2185 6.15526 19.9776 7.97949C20.8614 8.8961 21.5302 9.81037 21.9786 10.4951C22.2032 10.8382 22.3739 11.1263 22.4893 11.3301C22.5448 11.428 22.6334 11.5939 22.667 11.6572L22.6709 11.665C22.7694 11.8623 22.7754 12.0933 22.6885 12.2959L22.6856 12.3037C22.6558 12.3683 22.5778 12.5368 22.5284 12.6357C22.4254 12.8416 22.2722 13.1319 22.0664 13.4775C21.6559 14.1673 21.0317 15.088 20.1748 16.0107C18.4616 17.8558 15.776 19.75 12 19.75C8.22406 19.75 5.53851 17.8557 3.82524 16.0107C2.96845 15.088 2.34423 14.1673 1.93364 13.4775C1.72792 13.1319 1.57466 12.8416 1.47172 12.6357C1.42248 12.5372 1.34459 12.3689 1.31449 12.3037L1.31059 12.2959C1.22977 12.1073 1.22984 11.8927 1.31059 11.7041L1.31449 11.6963C1.34435 11.6316 1.42232 11.4631 1.47172 11.3643C1.57466 11.1584 1.72792 10.8681 1.93364 10.5225C2.34423 9.83268 2.96845 8.91195 3.82524 7.98926C5.53851 6.14426 8.22406 4.25 12 4.25ZM12.3692 8.20312C12.1972 7.93283 11.8029 7.93283 11.6309 8.20312L11.1329 8.98438C10.5825 9.84908 9.84912 10.5825 8.98442 11.1328L8.20317 11.6309C7.93287 11.8029 7.93287 12.1971 8.20317 12.3691L8.98442 12.8672C9.84912 13.4175 10.5825 14.1509 11.1329 15.0156L11.6309 15.7969C11.8029 16.0672 12.1972 16.0672 12.3692 15.7969L12.8672 15.0156C13.4175 14.1509 14.151 13.4175 15.0157 12.8672L15.7969 12.3691C16.0672 12.1971 16.0672 11.8029 15.7969 11.6309L15.0157 11.1328C14.151 10.5825 13.4175 9.84908 12.8672 8.98438L12.3692 8.20312Z"
        fill={fillColor}
      />
    </svg>
  );
}
